<template>
<div>
    <div ref="header" class="z-1 w-100 " :class="{'fade-in':header,'fixed':header||blog,'absolute':!header,'white':blog,'box-shadow':blog}">
        <v-row>
            <v-col cols="8" xl="3" lg="4" md="4" sm="8" class="">
                <div class=" mx-xl-6 mx-lg-6 mx-md-6 mx-sm-4 mx-xs-4 mx-3    mt-xl-6 mt-lg-6 mt-md-6 mt-sm-4 mt-xs-4 mt-3">
                    <router-link to="/" :class="{'noevent':$route.path=='/'}">
                        <Rogo13 />
                    </router-link>
                </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col xl="9" lg="8" md="8" class="disno-sm">
                <router-link to="/contact">
                    <div class="contact float-right f-white flex-center text-center f-10 ml-lg-9">
                        <div>お問合せ<br>ご予約</div>
                    </div>
                </router-link>
                <div class="float-right mt-3">
                    <router-link :to="menu.path" v-for="menu in menus" :key="menu.path">
                        <div class="float-left mx-6 mx-xl-14 mx-lg-7 pt-5 font_color f-12" v-text="menu.text"></div>
                    </router-link>
                    <div class="clear"></div>
                </div>
                <div class="clear"></div>
            </v-col>
            <v-col cols="4" sm="4" class="dis-sm text-right">
                <v-icon class="f-15  mr-3 mt-3  pointer" @click="drawer=true">fas fa-bars</v-icon>

            </v-col>
        </v-row>
    </div>
    <v-navigation-drawer v-model="drawer" fixed right>
        <v-card flat>

            <router-link to="/contact">
                <div class="contact  f-white flex-center text-center f-12">
                    <div>MENU</div>
                </div>
            </router-link>
            <ul class="mt-7">
                <li v-for="menu in menus" :key="menu.text">
                    <router-link :to="menu.path">
                        <div class="f-gray f-10 my-5 mx-2" v-text="menu.text" @click="drawer=false"></div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/faq">
                        <div class=" f-gray f-10 my-5 mx-2" @click="drawer=false">よくある質問</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/contact">
                        <div class=" f-gray f-10 my-5 mx-2" @click="drawer=false">お問合せ･ご予約</div>
                    </router-link>
                </li>
            </ul>
            <div class="mt-10 mr-6">
                <a href="https://www.instagram.com/bayside104/" target="_blank">
                    <svg ref="svg2" class=" insta  float-right mx-2 relative" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.25 448.15">
                        <path d="M224.1,141A114.9,114.9,0,1,0,339,255.9,114.72,114.72,0,0,0,224.1,141Zm0,189.6a74.7,74.7,0,1,1,74.7-74.7,74.84,74.84,0,0,1-74.7,74.7ZM370.5,136.3a26.8,26.8,0,1,1-26.8-26.8A26.74,26.74,0,0,1,370.5,136.3Zm76.1,27.2c-1.7-35.9-9.9-67.7-36.2-93.9s-58-34.4-93.9-36.2c-37-2.1-147.9-2.1-184.9,0C95.8,35.1,64,43.3,37.7,69.5s-34.4,58-36.2,93.9c-2.1,37-2.1,147.9,0,184.9,1.7,35.9,9.9,67.7,36.2,93.9s58,34.4,93.9,36.2c37,2.1,147.9,2.1,184.9,0,35.9-1.7,67.7-9.9,93.9-36.2s34.4-58,36.2-93.9c2.1-37,2.1-147.8,0-184.8ZM398.8,388a75.63,75.63,0,0,1-42.6,42.6c-29.5,11.7-99.5,9-132.1,9s-102.7,2.6-132.1-9A75.63,75.63,0,0,1,49.4,388c-11.7-29.5-9-99.5-9-132.1s-2.6-102.7,9-132.1A75.63,75.63,0,0,1,92,81.2c29.5-11.7,99.5-9,132.1-9s102.7-2.6,132.1,9a75.63,75.63,0,0,1,42.6,42.6c11.7,29.5,9,99.5,9,132.1S410.5,358.6,398.8,388Z" transform="translate(0.07 -31.82)" /></svg>
                </a>
                <router-link to="/blog">
                    <svg ref="svg" class=" blog float-right mx-2 relative" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 429.83 441.28" @click="drawer=false">
                        <path d="M384.66 122.93v46.26c0 30.16.22 60.33-.08 90.49-.18 18-.63 36-2 53.88-1.38 18.28-17.41 35.8-35.51 39.36a144.67 144.67 0 01-26.18 2.51c-36.49.4-73 .45-109.47.5-14.54 0-26.59 6.14-38.05 14.34q-44.25 31.67-88.73 63c-4 2.83-8.47 5-13.56 8-.16-2.4-.36-3.95-.36-5.5v-73.49c0-6.79-.3-7.06-7.07-6.53-28.31 2.2-48.87-10.58-60.53-37A37.67 37.67 0 01.01 302.9c.07-65.17 0-130.33.23-195.49 0-3.07 1.67-6.29 3.08-9.18 7.08-14.56 16.25-27.36 32.16-33.15a55.9 55.9 0 0118.44-3.6q117.22-.36 234.47-.16c.93 0 1.87.15 3.77.31-1.39 1.7-2.18 2.85-3.15 3.82-8.83 8.85-17.55 17.8-26.63 26.38a12.52 12.52 0 01-7.8 3.23c-54.5.18-109 .1-163.48.15-11.49 0-23 .22-34.47.53-12.31.33-19.89 7.65-20.15 20.08-.37 17.32-.23 34.65-.24 52v111c0 7.66 0 15.33.29 23 .46 12.19 7.83 19.34 20.07 19.44 14.5.12 29 .19 43.49-.08 4.72-.09 6 1.64 6 6.11-.21 13.83-.13 27.66 0 41.49 0 1.53.82 3 1.25 4.57 1.47-.57 3.14-.87 4.39-1.75 19.48-13.67 39-27.3 58.3-41.2 8.77-6.31 18.41-8.82 29-8.83q62.74-.06 125.48-.29h2c16.87-.21 23.2-6.56 23.22-23.48q.06-67.23 0-134.49a13.84 13.84 0 014.67-10.9c9.1-8.8 17.93-17.89 26.88-26.84a21.66 21.66 0 013.38-2.64z" />
                        <path d="M332.39 42.98c6.34 6.43 12.5 12.72 18.71 19 11 11 21.81 22 33 32.79 3.3 3.17 2.93 4.9-.15 7.92-25.91 25.46-51.86 50.9-77.33 76.79-7.37 7.49-15.81 11.72-25.67 14.37-14.92 4-29.69 8.61-44.54 12.88a29.24 29.24 0 01-7.8 1.48 7.07 7.07 0 01-6.73-9.31c5.75-20.16 11.46-40.32 17.41-60.42a18.62 18.62 0 014.37-7.67q43.27-43.43 86.8-86.43a20.12 20.12 0 011.93-1.4zm-46.52 133c-7-6-5.62-13.13-5.62-19.8 0-4.64-1.74-6.36-6.35-6.85-6-.63-11.86-2.37-17.84-3.28-1.14-.17-3.34 1-3.67 2-2.94 9.17-5.86 18.37-8.19 27.71-1.25 5 5.51 11.23 10.23 9.88 5.91-1.68 11.75-3.6 17.62-5.42zM429.83 43.24c-.36 11.68-6.27 17-12.17 22.16-.52.45-2.82-.3-3.66-1.13-15.94-15.85-31.74-31.83-47.7-47.66-2.61-2.59-2.76-4.07.16-6.71 14.87-13.47 21.92-13.32 36.2 1.16 6.89 7 14.2 13.62 20.66 21 3.33 3.8 5.21 8.88 6.51 11.18zM89.93 251.25V228.3c0-2.54.3-4.68 3.67-4.66 8.31 0 16.63-.32 24.92 0 11.83.49 19 11.9 12.44 20.8-3.85 5.25-4.61 7.7.54 12.32 4.09 3.68 3.41 9.69 1.25 14.56a12.53 12.53 0 01-11.78 7.85c-8.81.11-17.63 0-26.43.24-3.48.07-4.72-1.36-4.67-4.74.13-7.81 0-15.63 0-23.44zm19.89 20.27h5.47c5.12-.13 9.56-3.84 9.65-8 .1-4.38-3.47-8-8.76-8.38a77.18 77.18 0 00-12.9 0 5.73 5.73 0 00-4.06 3.28c-2.6 10.17-.19 13.15 10.1 13.15zm0-24.89c1 0 2.62.19 4.29.19 5.79 0 8.94-2.4 9.15-6.94.22-4.77-2.93-8-8.46-8.5-2.65-.22-5.33-.06-8-.09-7.17-.08-7.79.51-7.84 7.5 0 7.94 0 8 8.14 7.84h2.75zM299.46 233.29c-4.27 4.08-7.13 5.53-11.67 1.42-5.28-4.77-11.92-5.28-18.69-2.11s-10.6 8.61-11.29 15.85c-1.57 16.4 10.35 27.12 25.1 23 5.13-1.45 8-5.32 10.25-9.62 1.32-2.5-.37-3.76-2.82-3.8-4 0-8 0-12 .12-3.16.12-4.63-1.12-4.58-4.35s2-3.76 4.64-3.73c7.16.06 14.33.17 21.49 0 3.41-.08 4.53 1.42 4.13 4.52-1.56 11.91-7.46 23.9-24.43 26-12.65 1.56-25.76-6.33-29.79-18.51-4.33-13.1-.94-25.69 9-33.29 9.56-7.34 24.32-8 34.19-1.3 2.19 1.52 4.05 3.65 6.47 5.8zM183.18 251.5c0-16.91 11.63-28.54 28.5-28.5s28.17 11.51 28.18 28.81c0 16.89-11.69 28.62-28.5 28.59s-28.18-11.74-28.18-28.9zm9.49.1c0 12.39 7.47 20.61 18.76 20.67 11 .06 19.13-8.5 19.29-20.43s-8.33-21.11-19.29-21c-11.17.09-18.76 8.54-18.76 20.76zM397.27 88.38c-1.26-1.06-2.44-1.92-3.47-2.94-16.26-16.25-32.45-32.58-48.81-48.74-2.72-2.69-3.16-4.32-.09-7.14 8.13-7.47 8.12-7.73 15.91-.06 15.08 14.85 30 29.88 45.06 44.73 2.32 2.29 2.55 4 .09 6.15-2.86 2.51-5.61 5.14-8.69 8zM144.24 251.6c0-7.66.1-15.32 0-23-.07-3.51 1-5.19 4.8-5.2s4.88 1.68 4.84 5.18c-.11 12.15 0 24.31-.06 36.46 0 6 .52 6.49 6.58 6.45 4.5 0 9 0 13.49-.1 2.93-.08 4.84.63 4.78 4.1-.06 3.17-1.79 3.92-4.52 3.89-8.65-.07-17.31-.13-26-.05-3.09 0-4-1.36-3.94-4.28.12-7.8.03-15.67.03-23.45z" /></svg>
                </router-link>
                <div class="clear"></div>
            </div>
        </v-card>
    </v-navigation-drawer>
</div>
</template>

<script>
import Rogo13 from "@/components/Rogo13.vue"
import d from "@/d"
export default {
    data() {
        return {
            menus: [{
                    "path": "/",
                    "text": "トップ"
                },
                {
                    "path": "/facility",
                    "text": "施設案内"
                },
                {
                    "path": "/fees",
                    "text": "料金"
                },
                {
                    "path": "/access",
                    "text": "アクセス"
                },
            ],
            show: true,
            header: true,
            blog: false,
            scroY: 0,
            drawer: false,
        }
    },
    props: {
        ScroY: Number,
    },
    components: {
        Rogo13
    },
    mounted() {
        // switch (location.hash) {
        //     case "":
        //         this.rogoType = 0
        //         break
        //     case "#rogo11":
        //         this.rogoType = 11
        //         break
        //     case "#rogo13":
        //         this.rogoType = 13
        //         break
        // }
    },
    methods: {
        scroll01() {
            if (this.ScroY > 10 && window.innerHeight + this.ScroY < document.getElementById('footer').getBoundingClientRect().top * 4 && location.pathname == "/") {
                this.show = false
            } else {
                this.show = true
            }
        },
        scrolly() {
            this.scroll01()
        },
        headerPosi() {
            if (this.$route.path != "/") {
                this.header = false
            } else {
                this.header = true
            }
            if (this.$route.path == "/blog") {
                this.blog = true
            } else {
                this.blog = false
            }
        },

    },

    watch: {
        async ScroY() {
            this.scrolly()
            if (this.$route.path == "/blog") {
                await d.sleep(50)
                if (this.ScroY >= this.scroY) {
                    this.$refs.header.classList.remove("top-in")
                    this.$refs.header.classList.add("top-out")
                    this.scroY = this.ScroY
                } else {
                    this.$refs.header.classList.remove("top-out")
                    this.$refs.header.classList.add("top-in")
                }
            }
        },
        show(val) {
            if (val) {
                this.$refs.header.classList.remove("top-out")
                this.$refs.header.classList.add("top-in")
            } else {
                this.$refs.header.classList.remove("top-in")
                this.$refs.header.classList.add("top-out")
            }
        },
        $route() {
            this.headerPosi()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/header.scss";
</style>
